<template>
    <div className="home">
        <DownloadResults/>
    </div>
</template>

<script>
// @ is an alias to /src
import DownloadResults from '@/components/DownloadResults.vue'

export default {
    name: 'DownloadView',
    components: {
        DownloadResults
    }
}
</script>
